import { removeTags, Swal } from 'larasnap/support';

const typeOptions = {
    question: {
        icon: 'question',
    },
    danger: {
        icon: 'warning',
        customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-default',
        },
    },
    delete: {
        icon: 'warning',
        customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-default',
        },
        confirmButtonText: 'Yes, Delete',
        cancelButtonText: 'Cancel',
    },
};

export const Confirm = options => {
    let html = options.message;

    if (removeTags(html).length > 55 && !options.align) {
        options.align = 'left';
    }

    if (options.align === 'left') {
        html = `<div class="text-left">${options.message}</div>`;
    }

    return Swal.fire({
        title: 'Heads Up!',
        html,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
        ...typeOptions[options.type ?? 'question'],
        ...options,
    });
};

Object.keys(typeOptions).forEach(type => {
    Confirm[type] = options => Confirm({ type, ...options });
});
